import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Dialog, DialogContent, Typography, Button, Tooltip,
} from '@material-ui/core';

class ModalConfirmation extends React.Component {
  static propTypes = {
    tooltipTitle: PropTypes.string,
    trigger: PropTypes.node.isRequired,
    onConfirm: PropTypes.func.isRequired,
  };

  static defaultProps = {
    tooltipTitle: 'Delete',
  };

  state = {
    modalOpened: false,
  };

  handleModalOpened = () => {
    this.setState({ modalOpened: true });
  };

  handleModalClose = () => {
    this.setState({ modalOpened: false });
  };

  render() {
    const { trigger, tooltipTitle, onConfirm } = this.props;

    return [
      <Tooltip key="trigger-node" title={tooltipTitle}>
        {React.cloneElement(trigger, {
          onClick: this.handleModalOpened,
          style: {
            cursor: 'pointer',
          },
        })}
      </Tooltip>,
      <div key="modal-form">
        <Dialog open={this.state.modalOpened} onClose={this.handleModalClose} fullWidth>
          <DialogContent>
            <Typography variant="title" gutterBottom>
              Are you sure?
            </Typography>
            <ButtonContainer>
              <Button color="primary" onClick={this.handleModalClose}>
                No
              </Button>
              <Button
                color="primary"
                onClick={() => {
                  onConfirm({ closeModal: this.handleModalClose });
                }}
              >
                Yes
              </Button>
            </ButtonContainer>
          </DialogContent>
        </Dialog>
      </div>,
    ];
  }
}

export default ModalConfirmation;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 30px;

  & > * + * {
    margin-left: 20px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ModalConfirmation/ModalConfirmation.js